(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["balance-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bs').forEach(function(root){
  if(root.dataset.ready)return;root.dataset.ready='1';
  var labels=JSON.parse(root.previousElementSibling.textContent);
  var data={weight:{label:labels["37"],value:'64,25',unit:'kg',color:'#5fe6d8',explain:labels["36"],path:'M12 50C35 50 40 75 64 67S99 49 116 82S150 110 169 98S209 130 230 117S281 142 328 127',end:127},fat:{label:labels["123"],value:'24,8',unit:'%',color:'#efba80',explain:labels["125"],path:'M12 38C44 38 50 75 77 60S107 92 140 88S175 118 200 110S275 136 328 139',end:139},muscle:{label:labels["124"],value:'41,2',unit:'%',color:'#a9d8ee',explain:labels["126"],path:'M12 140C37 140 59 112 80 122S124 102 155 104S200 72 229 76S290 40 328 44',end:44}};
  root.querySelectorAll('[data-bs-metric]').forEach(function(button){button.addEventListener('click',function(){var d=data[button.dataset.bsMetric];root.querySelectorAll('[data-bs-metric]').forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});root.querySelector('[data-bs-label]').textContent=d.label;root.querySelector('[data-bs-value]').textContent=d.value;root.querySelector('[data-bs-unit]').textContent=d.unit;root.querySelector('[data-bs-explain]').textContent=d.explain;var line=root.querySelector('[data-bs-line]');line.setAttribute('d',d.path);line.setAttribute('stroke',d.color);var dot=root.querySelector('[data-bs-dot]');dot.setAttribute('cy',d.end);dot.setAttribute('fill',d.color);});});
  var back=root.querySelector('[data-bs-back]');if(back)back.addEventListener('click',function(e){var box=document.querySelector('.b-info');if(box){e.preventDefault();box.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});}});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dm-final[data-event-date]').forEach(function (el) {
      var dateStr = el.getAttribute('data-event-date');
      if (!dateStr) return;
      var target = new Date(dateStr).getTime();
      if (isNaN(target)) return;
      var dEl = el.querySelector('[data-dm-days]');
      var hEl = el.querySelector('[data-dm-hours]');
      var mEl = el.querySelector('[data-dm-minutes]');
      var sEl = el.querySelector('[data-dm-seconds]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { dEl.textContent = '00'; hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00'; return; }
        dEl.textContent = pad(Math.floor(diff / 86400000));
        hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dm-hero[data-event-date]').forEach(function (el) {
      var dateStr = el.getAttribute('data-event-date');
      if (!dateStr) return;
      var target = new Date(dateStr).getTime();
      if (isNaN(target)) return;
      var dEl = el.querySelector('[data-dm-days]');
      var hEl = el.querySelector('[data-dm-hours]');
      var mEl = el.querySelector('[data-dm-minutes]');
      var sEl = el.querySelector('[data-dm-seconds]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { dEl.textContent = '00'; hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00'; return; }
        dEl.textContent = pad(Math.floor(diff / 86400000));
        hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-balance-promo-cro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const gallery = root.querySelector('.bcp-slides');
    const slides = [...root.querySelectorAll('.bcp-slide')];
    const thumbs = [...root.querySelectorAll('[data-slide]')];
    let index = 0;
    const move = n => { index = Math.max(0, Math.min(slides.length - 1, n)); gallery.scrollTo({ left: index * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
    root.querySelector('[data-prev]').addEventListener('click', () => move(index - 1));
    root.querySelector('[data-next]').addEventListener('click', () => move(index + 1));
    thumbs.forEach((el, n) => el.addEventListener('click', () => move(n)));
    gallery.addEventListener('scroll', () => { index = Math.round(gallery.scrollLeft / gallery.clientWidth); root.querySelector('[data-counter]').textContent = (index + 1) + ' / ' + slides.length; thumbs.forEach((el, n) => el.setAttribute('aria-pressed', String(n === index))); }, { passive: true });
    gallery.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(index + (e.key === 'ArrowRight' ? 1 : -1)); } });
    const form = root.querySelector('form');
    const sticky = root.querySelector('[data-sticky]');
    const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0.1 });
    observer.observe(form);
    const checkExpiry = () => { if (root.dataset.promo === 'true' && Date.now() >= Date.parse(root.dataset.end)) { root.dataset.promo = 'false'; root.querySelectorAll('[data-price]').forEach(el => el.textContent = root.dataset.base); root.querySelectorAll('[data-promo-only]').forEach(el => el.hidden = true); root.querySelector('[data-offer-note]').textContent = root.dataset.expired; form.querySelector('[name=discount]')?.remove(); } };
    checkExpiry();
    const timer = setInterval(() => { if (!root.isConnected) { clearInterval(timer); observer.disconnect(); } else checkExpiry(); }, 30000);
    let busy = false;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (busy) return;
      checkExpiry(); busy = true;
      const buttons = [...root.querySelectorAll('button[type=submit]')];
      const original = buttons.map(b => b.innerHTML);
      const error = root.querySelector('.bcp-error'); error.hidden = true;
      buttons.forEach(b => { b.disabled = true; b.textContent = root.dataset.busy; b.setAttribute('aria-busy','true'); });
      const base = window.Shopify?.routes?.root || '/';
      try {
        const body = new FormData(form);
        body.delete('return_to'); body.delete('discount');
        const response = await fetch(base + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        window.location.assign(root.dataset.promo === 'true' ? base + 'discount/BalWell273792?redirect=' + encodeURIComponent(base + 'cart') : base + 'cart');
      } catch (err) {
        error.textContent = err.message || root.dataset.error; error.hidden = false;
        buttons.forEach((b,i) => { b.disabled = false; b.innerHTML = original[i]; b.removeAttribute('aria-busy'); }); busy = false;
        error.scrollIntoView({ block: 'center' });
      }
    });
  };
  document.querySelectorAll('[data-balance-promo]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-balance-promo]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-colors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-wb-colors]');
    sections.forEach(function (section) {
      const slides = section.querySelectorAll('[data-wb-color-slide]');
      const dots   = section.querySelectorAll('[data-wb-color-pick]');
      const nameEl = section.querySelector('[data-wb-color-name]');
      const descEl = section.querySelector('[data-wb-color-desc]');
      if (!slides.length || !dots.length) return;

      function broadcast(dot) {
        if (!dot) return;
        const detail = {
          name: dot.dataset.name || '',
          desc: dot.dataset.desc || '',
          hex: dot.dataset.hex || '',
          variantId: dot.dataset.variant || ''
        };
        window.dispatchEvent(new CustomEvent('wb-color-change', { detail: detail }));
      }

      function activate(idx, opts) {
        opts = opts || {};
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-checked', i === idx ? 'true' : 'false');
        });
        const dot = dots[idx];
        if (dot) {
          if (nameEl) nameEl.textContent = dot.dataset.name || '';
          if (descEl) descEl.textContent = dot.dataset.desc || '';
          if (!opts.silent) broadcast(dot);
        }
      }

      dots.forEach(function (dot, idx) {
        dot.addEventListener('click', function () { activate(idx); });
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            const next = (idx + 1) % dots.length; dots[next].focus(); activate(next);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = (idx - 1 + dots.length) % dots.length; dots[prev].focus(); activate(prev);
          }
        });
      });

      // Anuncia el color por defecto al cargar para que preventa + sticky usen su variante
      requestAnimationFrame(function () { broadcast(dots[0]); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrappers = document.querySelectorAll('.wb-hero[data-event-date]');
    wrappers.forEach(function (wrap) {
      const dateStr = wrap.getAttribute('data-event-date');
      if (!dateStr) return;
      const target = new Date(dateStr).getTime();
      if (isNaN(target)) return;
      const dEl = wrap.querySelector('[data-wb-days]');
      const hEl = wrap.querySelector('[data-wb-hours]');
      const mEl = wrap.querySelector('[data-wb-minutes]');
      const sEl = wrap.querySelector('[data-wb-seconds]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        const diff = target - Date.now();
        if (diff <= 0) {
          dEl.textContent = '00'; hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00';
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        dEl.textContent = pad(d); hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-preventa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyColor(detail) {
      if (!detail) return;
      // Actualiza la lectura de color en preventa
      document.querySelectorAll('[data-wb-color-display]').forEach(function (el) {
        if (detail.name) el.textContent = detail.name;
      });
      document.querySelectorAll('[data-wb-color-dot]').forEach(function (el) {
        if (detail.hex) el.style.background = detail.hex;
      });
      // Inyecta variant id en TODOS los formularios de compra
      if (detail.variantId) {
        document.querySelectorAll('[data-wb-buy-form] [data-wb-variant-input]').forEach(function (input) {
          input.value = detail.variantId;
        });
      }
      // Marca el thumb activo en la propia preventa
      document.querySelectorAll('.wb-pre__colors .wb-pre__color').forEach(function (btn) {
        const match =
          (detail.variantId && btn.dataset.variant === detail.variantId) ||
          (!detail.variantId && detail.name && btn.dataset.name === detail.name);
        btn.classList.toggle('is-active', !!match);
        btn.setAttribute('aria-checked', match ? 'true' : 'false');
      });
    }
    window.addEventListener('wb-color-change', function (e) { applyColor(e.detail); });

    // Click en los thumbnails locales → emite el mismo evento
    document.querySelectorAll('.wb-pre__colors .wb-pre__color').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.dispatchEvent(new CustomEvent('wb-color-change', { detail: {
          name: btn.dataset.name || '',
          desc: btn.dataset.desc || '',
          hex:  btn.dataset.hex  || '',
          variantId: btn.dataset.variant || ''
        }}));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-pro-b-product"]) return;
  try {
    
(() => {
  function init() {
    const root = document.querySelector('.wb-b-extras');
    const main = document.querySelector('#hfp-buy [data-hfp-buy]');
    if (!root || !main || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const scope = root.closest('.shopify-section');
    const base = new URL(main.href, location.href);
    const inputs = [...root.querySelectorAll('[data-wb-extra]')];
    const links = [...document.querySelectorAll('[data-hfp-buy]')];
    const money = new Intl.NumberFormat('es-ES', {style:'currency',currency:root.dataset.currency || 'EUR'});
    const basePrice = Number(root.dataset.basePrice);
    const baseCompare = Number(root.dataset.baseCompare);
    const selection = scope.querySelector('[data-wb-b-selection]');
    const initialSelection = selection.textContent;
    let selectedUrl = base.href;
    let selectedCount = 0;
    let total = basePrice;
    const expiry = Date.parse(root.dataset.expiry);
    const text = (el,value) => {if (el && el.textContent !== value) el.textContent=value;};
    function update() {
      const expired = Date.now() >= expiry;
      if (expired) {
        const mask = root.querySelector('[data-discount]');
        if (mask) {mask.checked=false;mask.disabled=true;mask.closest('[data-wb-mask-card]').hidden=true;}
        scope.querySelectorAll('[data-wb-offer-note]').forEach(el=>el.hidden=true);
      }
      const selected = inputs.filter(el=>el.checked && !el.disabled);
      selectedCount=selected.length;
      total=basePrice+selected.reduce((sum,el)=>sum+Number(el.dataset.price),0);
      const compare=baseCompare+selected.reduce((sum,el)=>sum+Number(el.dataset.regular),0);
      const url=new URL(base.href);
      url.pathname=base.pathname+selected.map(el=>','+el.value+':1').join('');
      const codes=(url.searchParams.get('discount')||'').split(',').filter(code=>code && code!=='WELLTOBERPRO49');
      if(selected.some(el=>el.dataset.discount))codes.push('WELLTOBERPRO49');
      if(codes.length)url.searchParams.set('discount',codes.join(','));else url.searchParams.delete('discount');
      selectedUrl=url.href;
      links.forEach(el=>el.href=selectedUrl);
      text(scope.querySelector('[data-wb-b-total]'),money.format(total/100));
      const crossed=scope.querySelector('[data-wb-b-compare]');
      crossed.hidden=compare<=total;
      text(crossed,money.format(compare/100));
      text(selection,selected.length?'Highfly Pro + '+selected.map(el=>el.dataset.name).join(' + ')+'. Mochila y crema incluidas.':initialSelection);
      document.querySelectorAll('#hfp-sticky .hfp-sticky__price,#wb-satc [data-price]').forEach(el=>text(el,money.format(total/100)));
      document.querySelectorAll('#wb-satc [data-compare]').forEach(el=>text(el,compare>total?money.format(compare/100):''));
      document.querySelectorAll('[data-wb-monthly]').forEach(el=>text(el,money.format(Math.floor(total / Number(el.dataset.wbMonthly))/100)));
      document.querySelectorAll('[data-wb-financed-total]').forEach(el=>text(el,money.format(total/100)));
      root.querySelectorAll('[data-wb-extra-variant]').forEach(select=>{
        const item=select.closest('.wb-b-extra-item');
        text(item.querySelector('[data-extra-price]'),'+'+money.format(Number(select.selectedOptions[0].dataset.price)/100));
      });
    }
    root.addEventListener('change',event=>{
      if(event.target.matches('[data-wb-extra-variant]')){
        const select=event.target, option=select.selectedOptions[0];
        const input=select.closest('.wb-b-extra-item').querySelector('[data-wb-extra]');
        input.value=option.value;input.dataset.price=option.dataset.price;input.dataset.regular=option.dataset.price;
      }
      update();
    });
    document.addEventListener('click',event=>{
      if(event.target.closest('a[href="#wb-b-finance-conditions"]')){
        const details=document.getElementById('wb-b-finance-conditions');
        if(details)details.open=true;
        return;
      }
      const target=event.target.closest('#wb-satc [data-add],#wb-sticky [data-sticky-add],product-sticky-atc button,product-sticky-atc a');
      if(!target || !root.isConnected)return;
      update();
      if(!selectedCount)return;
      event.preventDefault();event.stopImmediatePropagation();location.assign(selectedUrl);
    },true);
    links.forEach(link=>link.addEventListener('click',()=>update()));
    window.addEventListener('pageshow',update);
    const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}if(Date.now()>=expiry){update();clearInterval(timer);}},30000);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-stickybar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-wb-sticky]');
    if (!bar) return;

    /* === Selector de color local en la sticky === */
    const dots = bar.querySelectorAll('[data-wb-color-pick]');
    const nameEl = bar.querySelector('[data-wb-color-display]');
    function setActive(idx, broadcast) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-checked', i === idx ? 'true' : 'false');
      });
      const dot = dots[idx];
      if (!dot) return;
      if (nameEl && dot.dataset.name) nameEl.textContent = dot.dataset.name;
      if (broadcast) {
        window.dispatchEvent(new CustomEvent('wb-color-change', { detail: {
          name: dot.dataset.name || '',
          desc: dot.dataset.desc || '',
          hex:  dot.dataset.hex  || '',
          variantId: dot.dataset.variant || ''
        }}));
      }
    }
    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { setActive(idx, true); });
    });

    /* Sincroniza la sticky cuando la sección de colores principal emite el evento */
    window.addEventListener('wb-color-change', function (e) {
      if (!e.detail) return;
      // encuentra el dot que corresponde
      let matchIdx = -1;
      dots.forEach(function (d, i) {
        if (e.detail.variantId && d.dataset.variant === e.detail.variantId) matchIdx = i;
        else if (!e.detail.variantId && e.detail.name && d.dataset.name === e.detail.name) matchIdx = i;
      });
      if (matchIdx >= 0) setActive(matchIdx, false); // sin re-broadcast (evita loop)
      else if (nameEl && e.detail.name) nameEl.textContent = e.detail.name;
    });

    /* === Visibilidad por scroll === */
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }

    const hero  = document.querySelector('.wb-hero');
    const preventas = document.querySelectorAll('.wb-pre, .wb-section--preventa');

    let pastHero = !hero;
    let onPreventa = false;
    const sync = () => bar.classList.toggle('is-visible', pastHero && !onPreventa);

    if (hero) {
      new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
    }
    if (preventas.length) {
      const ioP = new IntersectionObserver((entries) => {
        onPreventa = entries.some(e => e.isIntersecting);
        sync();
      }, { threshold: 0.30 });
      preventas.forEach(el => ioP.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-waitlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const forms = document.querySelectorAll('[data-wb-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const status = form.querySelector('[data-wb-status]');
        const submitLabel = form.querySelector('[data-wb-submit-label]');
        const submitBtn = form.querySelector('[type="submit"]');
        const success = form.parentElement.querySelector('[data-wb-success]');
        status.textContent = '';

        const companyId = form.dataset.companyId;
        const listId = form.dataset.listId;
        if (!companyId || !listId) {
          status.textContent = 'Configuración del formulario incompleta.';
          return;
        }

        const fd = new FormData(form);
        const email = (fd.get('email') || '').toString().trim();
        const name = (fd.get('name') || '').toString().trim();
        const city = (fd.get('city') || '').toString().trim();
        const wearable = (fd.get('wearable') || '').toString().trim();
        const consent = fd.get('consent');
        const smsOptin = !!fd.get('sms');
        const priorities = fd.getAll('priority');

        if (!email || !name || !city) {
          status.textContent = 'Completa nombre, email y ciudad.';
          return;
        }
        if (!consent) {
          status.textContent = 'Debes aceptar recibir comunicaciones para entrar en la waitlist.';
          return;
        }

        form.classList.add('is-loading');
        const originalLabel = submitLabel.textContent;
        submitLabel.textContent = 'Enviando…';
        submitBtn.disabled = true;

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.customSource || 'Wellbeinn Band Landing',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: name,
                    location: { city: city },
                    properties: {
                      'Wellbeinn Priority': priorities,
                      'Current Wearable': wearable || 'No indicado',
                      'Signup Source': 'wellbeinn-band-landing',
                      'SMS Optin': smsOptin
                    }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        };

        try {
          const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify(payload)
          });

          if (res.status === 202 || res.ok) {
            form.hidden = true;
            if (success) success.hidden = false;
            try { if (window._learnq) window._learnq.push(['identify', { $email: email, $first_name: name }]); } catch (_) {}
          } else {
            const body = await res.text();
            console.warn('Klaviyo subscribe error', res.status, body);
            status.textContent = 'No hemos podido procesar tu alta. Revisa el email o inténtalo en unos minutos.';
          }
        } catch (err) {
          console.error(err);
          status.textContent = 'Error de conexión. Vuelve a intentarlo.';
        } finally {
          form.classList.remove('is-loading');
          submitLabel.textContent = originalLabel;
          submitBtn.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
